import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectCadastralFieldsMeta } from '../../../selectors/rosreestrData';

interface IParams {
  setShowNoCadastralNumberButton(value: boolean): void;
}

/** Обрабатывает сохранение кадастрового номера (для эксперимента обязательного кадастрого номера участка) */
export const useCadastralNumbersSaveHandler = ({ setShowNoCadastralNumberButton }: IParams) => {
  const { cadastralNumber } = useSelector(selectCadastralFieldsMeta);

  useEffect(() => {
    if (cadastralNumber.errors.notFoundError) {
      setShowNoCadastralNumberButton(true);
    }
  }, [cadastralNumber.errors.notFoundError, setShowNoCadastralNumberButton]);
};
